import { Route } from 'react-router-dom';

import BasketCreate from './basket-create/basket-create.component';
import { BasketDetail } from './basket-detail/basket-detail.component';
import { BasketOverview } from './basket-overview';
import { BasketUpdate } from './basket-update/basket-update.component';

export function BasketRoutes() {
    return (
        <Route path='baskets'>
            <Route
                index
                element={<BasketOverview />}
            />
            <Route
                path='create'
                element={<BasketCreate />}
            />
            <Route path=':basketId'>
                <Route
                    path='detail'
                    element={<BasketDetail />}
                />
                <Route
                    path='update'
                    element={<BasketUpdate />}
                />
            </Route>
        </Route>
    );
}
